export default "__VITE_ASSET__B6qJsE9Q__"